import { LoanProgramChangeOwner } from 'constants/loanChanges';
import { LoanProgramFieldName } from 'constants/programs';

export const LOAN_PROGRAM_CHANGE_SOURCES = {
  [LoanProgramChangeOwner.PROGRAM]: {
    [LoanProgramFieldName.PROGRAM_CODE]: 'ProgramCode',
    [LoanProgramFieldName.PROGRAM_LOAN_TYPE]: 'ProgramLoanType',
    [LoanProgramFieldName.LOAN_TERM]: 'LoanTerm',
    [LoanProgramFieldName.AMORT_TERM]: 'AmortTerm',
    [LoanProgramFieldName.AMORTIZATION_TYPE]: 'AmortizationType',
    [LoanProgramFieldName.INTEREST_ONLY_PERIOD]: 'InterestOnlyPeriod',
    [LoanProgramFieldName.BALLOON_TERM_MONTHS]: 'BalloonPaymentTermMonths',
    [LoanProgramFieldName.ANNUAL_FEE]: 'AnnualFee',
    [LoanProgramFieldName.MONTHLY_FEE]: 'MonthlyFee',
  },
  [LoanProgramChangeOwner.ARM_TERMS]: {
    [LoanProgramFieldName.ARM_INITIAL_CAP]: 'InitialCap',
    [LoanProgramFieldName.ARM_ADJUSTMENT_CAP]: 'AdjustmentCap',
    [LoanProgramFieldName.ARM_SUBSEQUENT_CAP]: 'SubsequentCap',
    [LoanProgramFieldName.ARM_RATE_ADJ_PERIOD]: 'RateAdjustmentPeriod',
    [LoanProgramFieldName.ARM_SUB_RATE_ADJ_PERIOD]: 'SubsequentRateAdjustmentPeriod',
    [LoanProgramFieldName.ARM_FLOOR_RATE]: 'FloorMinimumRate',
    [LoanProgramFieldName.ARM_CEILING_RATE]: 'CeilingRate',
    [LoanProgramFieldName.ARM_ADJ_CHANGE_INDEX_RATE]: 'AdjustmentChangeIndexRate',
  },
  [LoanProgramChangeOwner.INDEX]: {
    [LoanProgramFieldName.INDEX_TYPE_ID]: 'IndexTypeId',
    [LoanProgramFieldName.INDEX_MARGIN]: 'Margin',
    [LoanProgramFieldName.INDEX_RATE]: 'Rate',
    [LoanProgramFieldName.INDEX_PERIOD_DAYS]: 'PeriodDays',
  },
  [LoanProgramChangeOwner.PREPAYMENT_PENALTY]: {
    [LoanProgramFieldName.PREPAY_FEATURE_TYPE]: 'FeatureType',
    [LoanProgramFieldName.PREPAY_MONTHS_IN_AFFECT]: 'MonthsInAffect',
    [LoanProgramFieldName.PREPAY_CHARGE_TERM_MONTHS]: 'PenaltyChargeTermMonths',
    [LoanProgramFieldName.PREPAY_CHARGE_RATE]: 'PenaltyChargeRatePercents',
    [LoanProgramFieldName.PREPAY_MAX_AMOUNT]: 'MaxPenaltyAmount',
    [LoanProgramFieldName.PREPAY_DESCRIPTION]: 'PrepaymentDescription',
  },
  [LoanProgramChangeOwner.INITIAL_DRAW_PERIOD]: {
    [LoanProgramFieldName.INIT_DRAW_PERIOD]: 'Period',
    [LoanProgramFieldName.INIT_DRAW_MIN_TYPE]: 'MinimumInitialDrawType',
    [LoanProgramFieldName.INIT_DRAW_MIN_PERCENT]: 'MinimumInitialDrawPercent',
    [LoanProgramFieldName.INIT_DRAW_MIN_AMOUNT]: 'MinimumInitialDrawAmount',
    [LoanProgramFieldName.INIT_DRAW_AMORT_TYPE]: 'AmortizationType',
    [LoanProgramFieldName.INIT_DRAW_VAR_RATE_TYPE]: 'Type',
  },
  [LoanProgramChangeOwner.REPAYMENT_PERIOD]: {
    [LoanProgramFieldName.REPAY_PERIOD]: 'Period',
    [LoanProgramFieldName.REPAY_TYPE]: 'Type',
  },
  [LoanProgramChangeOwner.LOAN_CHARACTERISTICS]: {
    [LoanProgramFieldName.CHAR_ARM]: 'Arm',
    [LoanProgramFieldName.CHAR_ASSUMABLE]: 'Assumable',
    [LoanProgramFieldName.CHAR_CONFORMING]: 'Conforming',
    [LoanProgramFieldName.CHAR_COUNSELING_REQUIRED]: 'CounselingRequired',
    [LoanProgramFieldName.CHAR_INTEREST_ONLY]: 'InterestOnly',
    [LoanProgramFieldName.CHAR_HAS_PREPAY_PENALTY]: 'HasPrepaymentPenalty',
    [LoanProgramFieldName.CHAR_RUN_AUS]: 'RunAus',
    [LoanProgramFieldName.CHAR_AFFORDABLE_LENDING]: 'AffordableLending',
    [LoanProgramFieldName.CHAR_TEXAS_CASH_OUT]: 'TexasCashOut',
    [LoanProgramFieldName.CHAR_DEMAND_FEATURE]: 'DemandFeature',
    [LoanProgramFieldName.CHAR_NEG_AMORT]: 'NegativeAmortization',
    [LoanProgramFieldName.CHAR_BALLOON_PAYMENT]: 'BalloonPayment',
    [LoanProgramFieldName.CHAR_BRIDGE_LOAN]: 'BridgeLoan',
    [LoanProgramFieldName.CHAR_CONSTRUCTION_ONLY]: 'ConstructionOnly',
    [LoanProgramFieldName.CHAR_MORE_THAN_2_PAYMENTS]: 'MoreThan2PaymentsCollected',
    [LoanProgramFieldName.CHAR_INTEREST_INCREASED]: 'InterestIncreasedAfterDefault',
    [LoanProgramFieldName.CHAR_DEMAND_CLAUSE]: 'DemandClause',
    [LoanProgramFieldName.CHAR_LENDER_PAID_MI]: 'LenderPaidMI',
  },
  [LoanProgramChangeOwner.ASSUMABLE_DETAILS_GROUP]: {
    [LoanProgramFieldName.ASSUMABLE_DETAILS]: 'AssumableDetails',
  },
};
